import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { promoCodes } from 'src/constants'
import { commonCtaText, commonTitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      title={commonTitleText.streamLiveTVSports}
      subtitle={
        <>
          Enjoy a special offer!
          <br />
          Save $25/mo off your first two months.
        </>
      }
      showRSN={true}
      offerCode={promoCodes.partner_offer}
      ctaText={commonCtaText.startWatchingForFree}
      noIndex={true}
    />
  )
}
